const EC = require('../../../lib');

module.exports = EC;
